import { AlertMessage, type AlertMessageProps } from './AlertMessage';

export type AlertToastProps = AlertMessageProps;

export function AlertToast({ sx, ...props }: AlertToastProps) {
  return (
    <AlertMessage
      {...props}
      sx={{
        position: 'fixed',
        padding: '20px',
        right: 0,
        top: '70px',
        zIndex: 1300,
        ...sx,
      }}
    />
  );
}
